// Copy this into the array below to add a new log entry.
// Markdown file goes at public/markdown/blog/log/<slug>.md (filename must match slug).
// {
//   title: 'Today I learned...',
//   slug: 'today-i-learned-something',
//   date: '2026-08-24',
//   excerpt: 'One-line summary shown in the list and used for search.',
//   tags: ['Tag One', 'Tag Two'],
// },

const data = [
  {
    title: 'Behavior Trees',
    slug: 'behavior-trees',
    date: '2026-08-23',
    // excerpt: 'One-line summary shown in the list and used for search.',
    tags: ['Autonomous Agents', 'AI'],
  },
];

export default data;
